import React, { useState } from "react";
import auth from "Auth";
import {
  SelectionState,
  RowDetailState,
  PagingState,
  IntegratedPaging,
  IntegratedSelection,
  FilteringState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import {
  Grid as DataGrid,
  Table,
  TableHeaderRow,
  TableRowDetail,
  TableSelection,
  PagingPanel,
  TableFilterRow,
} from "@devexpress/dx-react-grid-material-ui";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { getSalesRep, getSalesReps } from "queries";
import { Subscription } from "react-apollo";
import PropTypes from "prop-types";
import { Typography, withStyles } from "@material-ui/core";
import DealersGridCommandIcons from "../MyDealers/DealersGridCommandIcons";
import UnArchiveUserButton from "../MyDealers/UnArchiveUserButton";
import ArchiveUserButton from "../MyDealers/ArchiveUserButton";
import EditUserButton from "../MyDealers/EditUserButton";
const RowDetail = ({ row }) => (
  <div>
    <table cellSpacing="0" className="detailTable">
      <tbody>
        <tr>
          <td>Full Name:</td>
          <td>{row.name}</td>
        </tr>
        <tr>
          <td>Email:</td>
          <td>{row.email}</td>
        </tr>
        <tr>
          <td>Phone:</td>
          <td>{row.phone}</td>
        </tr>
        <tr>
          <td>Address:</td>
          <td>
            {row.address}&nbsp;{row.address2}
            <br />
            {row.city}&nbsp;{row.region}, {row.country} {row.zipcode}
            <br />
          </td>
        </tr>
        <tr>
          <td>Brands:</td>
          <td>
            <EditDealerDetails item={row} />
          </td>
        </tr>
        <tr>
          <td>
            <EditUserButton item={row} />
          </td>
          <td>
            {row.status === "archived" ? (
              <UnArchiveUserButton item={row} />
            ) : (
              <ArchiveUserButton item={row} />
            )}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: "none",
  },
  root: {
    padding: theme.spacing(),
  },
  item: {
    height: "100%",
  },
  marginFix: {
    marginTop: 19,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
  },
});

function EditDealerDetails({ item }) {
  const brands = [];
  if (item.has_skiff) brands.push("CAROLINA SKIFF");
  if (item.has_seachaser) brands.push("SEA CHASER");
  if (item.has_funchaser) brands.push("FUN CHASER");

  return <div>{brands.length > 1 ? "All" : brands.join(", ")}</div>;
}

const processBrandData = (item) => {
  const brands = [];
  if (item.has_skiff) brands.push("CAROLINA SKIFF");
  if (item.has_seachaser) brands.push("SEA CHASER");
  if (item.has_funchaser) brands.push("FUN CHASER");
  return brands.join(", ");
};

function BrandFormatter({ value }) {
  const brandNames = value.split(", ");
  return <div>{brandNames.join(", ")}</div>;
}

const BrandTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={BrandFormatter} {...props} />
);
function SalesGrid(props) {
  const { classes } = props;
  const columns = [
    { name: "created_at", title: "DATE ADDED" },
    { name: "company", title: "NAME" },
    { name: "brand", title: "BRAND" },
    { name: "email", title: "EMAIL" },
  ];
  const [selection, setSelection] = useState([]);
  const [dateColumns] = useState(["created_at"]);
  const getRowId = (row) => row.profile_id;
  const DateFormatter = ({ value }) =>
    value.replace(
      /(\d{4})-(\d{2})-(\d{2})(T\d{2}:\d{2}:\d{2}.\d{5,6}\+\d{2}:\d{2})/,
      "$2.$3.$1",
    );
  const DateTypeProvider = (props) => (
    <DataTypeProvider formatterComponent={DateFormatter} {...props} />
  );
  const [dealerStatus, setDealerStatus] = useState(
    localStorage.getItem("includeArchived") === "true" ? "%" : "active",
  );
  const brandColumn = ["brand"];

  return (
    <div className={classes.root}>
      <Subscription
        subscription={getSalesReps}
        variables={{ status: dealerStatus }}
      >
        {({ data, loading, error }) => {
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error {JSON.stringify(error)}</p>;
          const processedRows = data?.profiles?.map((row) => ({
            ...row,
            brand: processBrandData(row),
          }));
          return (
            <div className={classes.gridContainer}>
              <Typography gutterBottom variant="h2" className="addDealer">
                Total rows selected: {selection.length}
                <DealersGridCommandIcons
                  profiles={data.profiles}
                  saveSettings={(includeArchived) =>
                    setDealerStatus(includeArchived ? "%" : "active")
                  }
                />
              </Typography>
              <DataGrid
                rows={processedRows}
                columns={columns}
                getRowId={getRowId}
              >
                <BrandTypeProvider for={brandColumn} />
                <DateTypeProvider for={dateColumns} />
                <SelectionState
                  selection={selection}
                  onSelectionChange={setSelection}
                />
                <FilteringState defaultFilters={[]} />
                <IntegratedFiltering />
                <PagingState defaultCurrentPage={0} pageSize={10} />
                <IntegratedSelection />
                <IntegratedPaging />
                <RowDetailState defaultExpandedRowIds={[0]} />
                <Table />
                <TableHeaderRow />
                <TableFilterRow />
                <TableRowDetail contentComponent={RowDetail} />
                <TableSelection showSelectAll />
                <PagingPanel />
              </DataGrid>
            </div>
          );
        }}
      </Subscription>
    </div>
  );
}

SalesGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(SalesGrid);
